// extracted by mini-css-extract-plugin
export default {"root":"_35z5_"};